import { makeObservable, override } from 'mobx';

import { EhrData, EhrSearchQuery } from 'chaika-frontend-types/frontend-cms';

import { PatientList } from '@patient/store/patient/PatientList';
import { Ehr } from '@patient/store/ehr/Ehr';
import { SearchList } from '@store/abstract/SearchList';

export class SearchPatientList extends SearchList<Ehr, EhrData, EhrSearchQuery> {
    constructor() {
        super(PatientList as any);
        makeObservable(this);
    }

    @override
    public get searchParamsSet(): boolean {
        const { query = '' } = this.searchParams;

        return Object.keys(this.filterParams).length > 0 && query.trim().length > 0;
    }
}
